import React from "react";
import ServicePageLayout from "../components/ServicePageLayout";
import RequestForm from "../components/RequestForm";
import { useGuestSession } from "contexts/GuestSessionContext";

const CatalogRequestPage = ({ catalogKey, title }) => {
  const { portalConfig, locationLabel } = useGuestSession();
  const catalog = portalConfig.catalogs[catalogKey];

  return (
    <ServicePageLayout
      title={title}
      subtitle={`We’ll send this to ${locationLabel}. Add a note if you need something specific.`}
      illustration={catalogKey}
    >
      <RequestForm catalog={catalog} type={catalogKey} locationLabel={locationLabel} />
    </ServicePageLayout>
  );
};

export default CatalogRequestPage;
